import { Icon } from "@circleco/compass/components/Icon";
import type { MouseEventHandler } from "react";

import { t } from "@/i18n-js/instance";

export interface RemoveButtonProps {
  onClick: MouseEventHandler<HTMLButtonElement>;
}

export const RemoveButton = ({ onClick }: RemoveButtonProps) => (
  <button
    type="button"
    onClick={onClick}
    aria-label={t("close")}
    className="bg-inverse absolute -right-2 -top-2 z-[1] hidden size-6 cursor-pointer items-center justify-center rounded-full border-2 border-white group-hover:flex"
  >
    <Icon name="cross-small" size="sm" color="inverse" />
  </button>
);
